module.exports = __webpack_public_path__ + "static/media/1015830.3676e60c.png";